<template>
  <section class="f-55">
    <div class="alive-3-content">
      <div class="font-group">
        <div class="title f-center-title">超强记忆，全家习惯牢牢记住</div>
        <div class="des f-center-sub-title">
          通过声纹识别，记忆座椅偏好/空调温度/娱乐习惯等等，提供预判式主动关怀
        </div>
      </div>
      <img src="@/v2/auto/assets/image/55/0.jpg" v-ia />
    </div>
  </section>
</template>

<script>
export default {
  name: 'BeautyAlive',
  data() {
    return {
      preload_: true,
    }
  },
}
</script>

<style lang="less" scoped>
.f-55 {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #000000;
  .alive-3-content {
    width: 100%;
    padding: 200px 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .font-group {
    position: absolute;
    top: 300px;
    width: 100%;
    display: flex;
    z-index: 1;
    flex-direction: column;
    align-items: center;
    color: #ffffff;

    .title {
      font-weight: bold;
      text-align: center;
      display: inline-block;
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .des {
      text-align: center;
      line-height: 24px;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
}
</style>
